import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
	logoContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	logoText: {
		fontSize: 22,
		fontWeight: 500,
		fontFamily: 'Inter',
	},
	hide: {
		display: 'none',
	},
	menuButton: {
		marginRight: theme.spacing(1),
	},
	button: {
		background: theme.palette.primary.light,
		'&:hover': {
			background: theme.palette.primary.dark + '!important',
		},
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
	},
	logo: {
		width: 99,
	},
}));
